import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { DynamicRemoteFederatedComponent } from '../app-dynamic-remote';
import { Login } from '../pages/login';
import { ForgotPassword } from '../user-management/registration/ForgotPassword';
import { Registration } from '../user-management/registration/Registration';
import { ResetPassword } from '../user-management/registration/ResetPassword';
import { availableRoutes } from './available-routes';

function UnauthorizedRoutes() {
  return (
    <Routes>
      <Route key="login" path={availableRoutes.login} element={<Login />} />
      {/* {[availableRoutes.setNewPassword].map((path) => (
        <Route key={path} path={path} element={<PasswordReset />} />
      ))} */}
      <Route
        key="forgotpassword"
        path={availableRoutes.forgotpassword}
        element={<ForgotPassword />}
      />

      <Route
        key="passwordreset"
        path={availableRoutes.passwordReset}
        element={<ResetPassword />}
      />
      <Route
        key="register"
        path={availableRoutes.register}
        element={<Registration />}
      />
      <Route
        key="shipmentExecution"
        path={availableRoutes.shipmentExecution}
        element={
          <DynamicRemoteFederatedComponent exposedFrom="shipmentExecution/App" />
        }
      />
      <Route
        path="*"
        element={<Navigate replace to={availableRoutes.login} />}
      />
    </Routes>
  );
}

export default UnauthorizedRoutes;
